import { Grid } from '@mui/material';
import CourseCard from '../components/CourseCard';
import Section from '../components/Section';

/**
 * The information for a course preview card
 */
export interface CoursePreview {
  /**
   * The title of the course
   */
  title: string;

  /**
   * The slug for the course's navigation
   */
  slug: string;

  /**
   * The user's progress through the course between 0-100%
   */
  progress: number;

  /**
   * The base color of the card for the course
   */
  baseColor: string;
  /**
   * Whether the organization requires the training
   */
  required: boolean;
}

/**
 * The properties for the course section
 */
interface CourseSectionProps {
  /**
   * The information for the course previews
   */
  coursePreviews: CoursePreview[];
}

/**
 * A section within the training page to show the available courses
 */
const CourseSection = (props: CourseSectionProps) => {
  return (
    <Section title="Courses">
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {props.coursePreviews.map((c, i) => (
          <Grid item height="15em" xs={12} sm={6} key={i}>
            <CourseCard {...c} />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
};

export default CourseSection;
